<script setup>
// LIBRARIES
import { defineAsyncComponent, onMounted, reactive } from 'vue';
import { RouterView } from "vue-router";
import pinia from '@/store.js';

// STORES
import { useForcePortraitStore } from '@/stores/ForcePortraitStore.js';
import { useLoadingMsgStore } from '@/stores/LoadingMsgStore.js';
const forcePortraitStore = useForcePortraitStore(pinia);
const loadingMsgStore = useLoadingMsgStore(pinia);

// COMPONENTS
const NavigationComponent = defineAsyncComponent(() => import('@/components/NavigationComponent.vue'));
const LoadingMsgComponent = defineAsyncComponent(() => import('@/components/LoadingMsgComponent.vue'));
const ForcePortraitComponent = defineAsyncComponent(() => import('@/components/ForcePortraitComponent.vue'));

const state = reactive({
    updateneeded: false
});

function checkOrientation() {
    // console.log('window resizing')
    let winheight = window.outerHeight;
    let winwidth = window.outerWidth;

    if ((winwidth > winheight) && (winwidth != forcePortraitStore.originalWindowWidth)) {
        forcePortraitStore.$patch({
            forceportrait: true
        });

    } else {
        forcePortraitStore.$patch({
            forceportrait: false
        });
    }
}

function sOWH(val) {
    forcePortraitStore.$patch({
        originalWindowHeight: val
    });
}

function sOWW(val) {
    forcePortraitStore.$patch({
        originalWindowWidth: val
    });
}

function requestUpdate() {
    state.updateneeded = false;
    window.location = window.location;
}

onMounted(() => {
    sOWH(window.outerHeight);
    sOWW(window.outerWidth);
    window.onresize = () => {
        checkOrientation();
    }

    const registerServiceWorker = async () => {
        if ("serviceWorker" in navigator) {
            console.log('setting onmessage')
            navigator.serviceWorker.onmessage = (event) => {
                // Print the result
                console.log("navigator.serviceWorker:", event.data);
                if (event.data) {
                    if (event.data.payload == 'update') {
                        state.updateneeded = true;

                    } else if (event.data.payload == 'unregister') {
                        navigator.serviceWorker.getRegistration()
                            .then((reg) => {
                                if (reg) {
                                    reg.unregister();
                                }
                            })
                    }
                }
            };

            try {
                navigator.serviceWorker.register(
                    // '/sw.js', { scope: scopedPath, }
                    '/sw.js', { scope: '/', }
                ).then((registration) => {
                    if (registration.installing) {
                        console.log('Service worker installing');
                    } else if (registration.waiting) {
                        console.log('Service worker installed');
                    } else if (registration.active) {
                        console.log('Service worker active');
                        registration.active.postMessage({
                            type: 'UNREGISTER'
                        })
                    }

                });


            } catch (error) {
                console.error(`Registration failed with ${error}`);
            }

        } else {
            console.log('navigator.serviceWorker does not exist')
        }
    }

    if(! import.meta.env.VITE_DEV_PROXY_TARGET.includes('dev')) {
      registerServiceWorker();
    }

});
</script>

<style lang="scss">
@use '@/assets/css/modal.scss';
</style>

<style lang="scss">
body {
    margin: 0;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,Liberation Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
}
html {
    font-family: sans-serif;
    line-height: 1.15;
    width: 100%;
    background-color: #ededed;
}

#app {
    margin: 0;
    padding: 0;
    min-height: 100vh;
    max-height: 100vh;
    position: absolute;
    top: 0;
    min-width: 100vw;
    max-width: 100vw;
    background-color: white;
}
.container {
    display: flex;
    padding: 0;
    margin: 0;
    width: 100%;
}
.container-block {
    display: block;
    padding: 0;
    margin: 0;
    width: 100%;
}

.col-1 {
    display: grid;
    width: 8.3%;
}
.col-10 {
    display: grid;
    width: 83.3%;
}
.max-100 {
    width: 100%;
}
.align-h-center {
    display: flex;
    justify-content: center;
}
.px-0 {
    padding: 0;
}
.max-100 {
    margin: 0;
    padding: 0;
    min-width: 100%;
    max-width: 100%;
}
.mx-0 {
    margin: 0;
}
.app-update-needed-button {
    background-color: #0f70b7;
    border-radius: 0.75em;
    background-color: #0f70b7;
    color: white;
    border: 1px solid #0f70b7;
    padding: 0.35em 1em 0.25em;
    font-size: 1.25em;
    margin-left: auto;
    margin-right: auto;
    display: flex;
}
</style>

<template>
<!-- App Update Prompt -->
<Teleport to="body" v-if="state.updateneeded">
    <div id="app-update-needed-modal-outer">
        <div id="app-update-needed-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div>App has an update!</div>
                    </div>
                    <div class="modal-body">
                        <button class="app-update-needed-button" @click.prevent="requestUpdate()">Update</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="app-update-needed-backdrop" class="modal-backdrop"></div>
    </div>
</Teleport>

<NavigationComponent />
<LoadingMsgComponent v-if="! loadingMsgStore.offline && loadingMsgStore.loadingmsg" />
<ForcePortraitComponent v-if="forcePortraitStore.forceportrait" />
<RouterView />
</template>
